import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';

const ScrollProgress: React.FC = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: `${scrollProgress}%`,
        height: '3px',
        backgroundColor: 'primary.main',
        zIndex: 1000,
        transition: 'width 0.1s ease-out',
        boxShadow: '0 0 10px rgba(25, 118, 210, 0.5)',
      }}
    />
  );
};

export default ScrollProgress;